import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { SPECIAL_CHARS_FORMAT, USER_PREFERENCE_SETS } from '../../../../common/utils/constants';
import { selectUserPreferences } from '../../../../redux/selectors';
import { selectUserCategoryPreferences } from '../../../../redux/UserPreferences';
import { fallbackByCategory } from '../constants';

function useValidatePreference({ category }) {
  const fallbackIds = fallbackByCategory[category];
  const byId = useSelector((state) => selectUserPreferences(state).byId);
  const ids = useSelector((state) => selectUserCategoryPreferences(selectUserPreferences(state), category).ids);

  return useCallback(
    (preference) => {
      const errors = {};
      const preferenceIds = fallbackIds ? [...ids.filter((id) => id !== preference.preferenceId), ...fallbackIds] : ids;
      let chartFormat = 'Chart';
      if (category === USER_PREFERENCE_SETS.CHART_SET) chartFormat += ' set';

      const trimmedPreferenceName = preference.name.trim();

      if (trimmedPreferenceName.length === 0) {
        errors.name = `${chartFormat} name cannot be empty.`;
      } else if (trimmedPreferenceName.length > 50) {
        errors.name = 'Number of characters should NOT be more than 50.';
      } else if (SPECIAL_CHARS_FORMAT.test(trimmedPreferenceName)) {
        errors.name = `${chartFormat} name should NOT contain special character.`;
      } else if (preferenceIds.some((id) => trimmedPreferenceName === byId[id].name)) {
        errors.name = `${chartFormat} name already exists.`;
      }

      return errors;
    },
    [category, ids, fallbackIds, byId]
  );
}

export default useValidatePreference;
